export default "__VITE_PUBLIC_ASSET__c359501e__"